import { teamContext } from "@redotech/feature-flags-model/context";
import { featureFlag } from "@redotech/openfeature-contracts/flag";

export const labelPrebuyFlag = featureFlag(
  "oms-label-prebuy",
  teamContext,
).boolean(false);

export const scanItemizedStateSyncFlag = featureFlag(
  "oms-scan-itemized-state-sync",
  teamContext,
).boolean(false);

export const scanWaitForLabelPrintFlag = featureFlag(
  "oms-scan-wait-for-label-print",
  teamContext,
).boolean(false);

/** The redesigned shipment details workspace in Shipping > Fulfillments. */
export const newShipmentDetailsFlag = featureFlag(
  "new-shipment-details",
  teamContext,
).boolean(false);

/** The custom label section and its layout editor in OMS print settings. */
export const shippingLabelBuilderFlag = featureFlag(
  "shipping-label-builder",
  teamContext,
).boolean(false);

/** The composable merchant dashboards page in the warehouse app. */
export const wmsCustomDashboardsFlag = featureFlag(
  "wms-custom-dashboards",
  teamContext,
).boolean(false);

/** The Temu OMS integration card; off until Temu approves our app. */
export const temuIntegrationFlag = featureFlag(
  "temu-integration",
  teamContext,
).boolean(false);

/** Connecting Redo as a team's Mintsoft courier. */
export const mintsoftCourierFlag = featureFlag(
  "mintsoft-courier",
  teamContext,
).boolean(false);

/** Connecting Redo as a courier in a team's Linnworks account. */
export const linnworksCourierFlag = featureFlag(
  "linnworks-courier",
  teamContext,
).boolean(false);

/** Legacy OMS reports: the old Settings > Reports entry and the label purchases report. */
export const analyticsLegacyReportsSettingsFlag = featureFlag(
  "analytics-legacy-reports-settings",
  teamContext,
).boolean(false);
